
export default function * success (res) {
// console.log("from resend verification success",res);
 
}
